import React, { useEffect, useState } from "react";
import { BsChevronDoubleRight } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";

import useApiRequest from "../../hooks/useApiRequest";
import Spinner from "../shared/spinner";
import { getGroupedData } from "../../utils/helpers";

const VehicleModels = ({ changeBanner }) => {
  useEffect(() => {
    changeBanner(false);
  }, []);

  let { vehicleBrandId, vehicleSeriesId, vehicleModelId } = useParams();


  const { data, isLoading, error } = useApiRequest(`/${vehicleBrandId}?type=${vehicleBrandId}&makes_id=${vehicleSeriesId}&models_id=${vehicleModelId}`);

  const navigate = useNavigate();

  const goBackToSeriesSelection = () => {
    navigate(`/${vehicleBrandId}/${vehicleSeriesId}`);
  };

  const goToVehicleEngines = (engineId) => {
    navigate(`/${vehicleBrandId}/${vehicleSeriesId}/${vehicleModelId}/${engineId}`);
  };

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600); // Adjust the breakpoint as needed

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 600); // Adjust the breakpoint as needed
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-center justify-center mt-12 mb-6 gap-5 p-6" style={{ background: "#e6e6e6" }}>
        <Link to={`/${vehicleBrandId}`} className="font-bold text-base sm:text-xl">{`${vehicleBrandId.charAt(0).toUpperCase()}${vehicleBrandId.substring(1)}`}</Link>
        {isSmallScreen ? <FaAngleDown /> : <BsChevronDoubleRight />}
        <a className="font-bold text-base sm:text-xl flex flex-row gap-2 items-center justify-center cursor-pointer" onClick={goBackToSeriesSelection}>
          <img
            src={data ? data[0]?.makes?.imageUrl : window.DEFAULT_IMAGE_URL}
            className="w-8 h-8"
            onError={(e) => {
              e.target.src = window.DEFAULT_IMAGE_URL;
            }}
          />
          <p>{data ? data[0]?.makes?.name : ""}</p>
        </a>
        {isSmallScreen ? <FaAngleDown /> : <BsChevronDoubleRight />}
        <a className="font-bold text-base sm:text-xl flex flex-row gap-2 items-center justify-center">
          {data && data[0]?.models?.imageUrl && (<img
            src={data ? data[0]?.models?.imageUrl : window.DEFAULT_IMAGE_URL}
            className="w-8 h-6"
            onError={(e) => {
              e.target.src = window.DEFAULT_IMAGE_URL;
            }}
          />)}
          <p>{data ? data[0]?.models?.name : ""}</p>
        </a>
      </div>
      <h1 className="flex items-center justify-center mt-12 mb-6 font-bold text-center text-2xl sm:text-4xl" style={{ color: "#121212" }}>
        Select the Model for {data ? data[0]?.makes?.name : ""} {data ? data[0]?.models?.name : ""}
      </h1>
      <div className="flex flex-wrap justify-center gap-8">
        {getGroupedData(data, "generations_id")?.map((brand, index) => (
          <div
            key={index}
            className="bg-white rounded-lg overflow-hidden shadow-xl hover:shadow-xl hover:translate-y-1 hover:flip vehicleSeriesCards"
            style={{ minHeight: "200px", width: "300px", padding: "12px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'space-around' }}
            onClick={() => {
              goToVehicleEngines(brand?.generations_id);
            }}
          >
            {data[0]?.models?.imageUrl !== "" && (<img
              src={data[0]?.models?.imageUrl || window.DEFAULT_IMAGE_URL}
              alt={`${brand?.name} Logo`}
              className="object-cover object-center transition-transform"
              style={{ width: "100px" }}
              onError={(e) => {
                e.target.src = window.DEFAULT_IMAGE_URL;
              }}
            />)}
            <div className="p-2 text-center">
              <p className="text-lg font-semibold">{brand?.generations?.name}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-12 mb-6 flex items-center justify-end p-6 backButtonBrand">
        <button className="btnn btnBrandd" style={{ borderRadius: "8px" }} onClick={goBackToSeriesSelection}>
          Go Back To Series Selection
        </button>
      </div>
    </div>
  );
};

export default VehicleModels;
